import React, { useRef } from "react";
import identificationCard from '../../images/detail/identification-card.png';
import identificationIntroduction from '../../images/detail/identification-introduction.png';
import { FoodNutritionLabel } from "./FoodNutritionLabel";
import WechatOpenAppButton from "./WechatOpenAppButton";

export const FoodRecognitionComponent: React.FC<{ data?: any, imageUrl: string | null }> = ({
    data,
    imageUrl,
}) => {
    const wechatOpenAppRef = useRef<any>(null);

    const handleFoodNutritionClick = () => {
        if (wechatOpenAppRef.current) {
            wechatOpenAppRef.current.triggerAppLaunch();
        }
    };

    return (
        <>
            <div className="pulse-info" style={{ width: '100vw' }}>
                <span className="pulse-text">智能识菜详情</span>
                <span className="time-text">{data?.createAt}</span>
                <div style={{
                    marginTop: 20,
                    position: 'relative',
                    textAlign: 'center',
                    backgroundImage: `url(${identificationCard})`,
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '40px 20px 20px',
                }}>
                    <WechatOpenAppButton
                        ref={wechatOpenAppRef}
                        style={{ display: 'none' }}
                        buttonText="" />
                    {/* 图片展示区域 */}
                    {data?.generatePictureData?.qwenAnimationUrl && (
                        <div style={{ position: 'relative' }} onClick={handleFoodNutritionClick}>
                            <FoodNutritionLabel
                                key={`food-nutrition-${data?.createAt}`}
                                imageUrl={imageUrl}
                                foodData={data?.recognitionData}
                            />
                        </div>
                    )}

                    {/* 文字介绍区域 */}
                    <div style={{
                        marginTop: 20,
                        position: 'relative',
                        textAlign: 'center',
                        backgroundImage: `url(${identificationIntroduction})`,
                        backgroundSize: '100% 100%',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '15px',
                        margin: '6vw'
                    }}>
                        <div style={{
                            fontWeight: 600,
                            fontSize: '18px',
                            lineHeight: '25px',
                            color: '#94724B',
                            textAlign: 'center',
                            maxWidth: '100%',
                            wordWrap: 'break-word',
                            wordBreak: 'break-word',
                            whiteSpace: 'normal',
                        }}>
                            {data?.summaryData?.summary?.emotional_summary}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};